var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { ROUTES } from "@ane/exp-data/lib/routes/Routes.constants";
import { produceUserContextRouteQueryStringEpics } from "@ane/core/lib/services/syncUrlAndStore/ProduceUserContextRouteQueryStringEpics";
import { EXP_QUERY_STRINGS } from "@ane/core/lib/constants/QueryString.constants";
import { ExtensionsContextParams } from "./module/views/utils/ExtensionsContext.js";
import extensionsConstants from "./module/views/utils/ExtensionsConstants.js";
import { actionTypes } from "./module/views/ducks/Extensions.ducks.types.js";
import { combineEpics } from "redux-observable";
import { loadResourcesUtils } from "@ane/core/lib/utils";
import ExtensionsResource from "@ane/exp-data/lib/resources/Extensions.resource";
import ScriptGenResource from "@ane/exp-data/lib/resources/ScriptGenResource";
const produceQueryStringEpic = (history) => {
  const setUserContextFromRouteQueryString = produceUserContextRouteQueryStringEpics(
    ExtensionsContextParams,
    (context) => setUserContextAction(context),
    extensionsConstants.SET_PARTIAL_USER_CONTEXT,
    extensionsConstants.SET_USER_CONTEXT,
    (store) => store.extensionContext,
    history,
    (pathname) => !!pathname && pathname.startsWith(`${ROUTES.extensions.root.match.path}`),
    EXP_QUERY_STRINGS
  );
  return combineEpics(
    setUserContextFromRouteQueryString.setUserContextFromPartial,
    setUserContextFromRouteQueryString.setUserContextFromQueryString
  );
};
const loadEmptyScorecardExtensionDataArgs = {
  actionPrefix: "EXTENSIONS/EMPTY_SCORECARD",
  reduxKeyNested: (payload) => ["emptyScorecardResponse", payload.scorecardId],
  loadResource: (payload, state) => {
    return ExtensionsResource.loadExtensionsResponse(
      payload.extensionName,
      payload.workspaceId,
      payload.scorecardId,
      payload.extensionData
    );
  },
  onCompleteSuccess: (result) => result
};
const loadEmptyScorecardExtensionDataEpic = loadResourcesUtils(loadEmptyScorecardExtensionDataArgs);
const loadMetricPowerExtensionDataArgs = {
  actionPrefix: "EXTENSIONS/METRIC_POWER",
  reduxKeyNested: (payload) => ["metricPowerResponse", payload.scorecardId],
  loadResource: (payload, state) => {
    return ExtensionsResource.loadExtensionsResponse(
      payload.extensionName,
      payload.workspaceId,
      payload.scorecardId,
      payload.extensionData
    );
  },
  onCompleteSuccess: (result) => result
};
const loadMetricPowerExtensionDataEpic = loadResourcesUtils(loadMetricPowerExtensionDataArgs);
const loadScriptGeneratorDataArgs = {
  actionPrefix: "EXTENSIONS/SCRIPT_GENERATOR",
  reduxKeyNested: (payload) => ["scriptGeneratorResponse", payload.scorecardId],
  loadResource: (payload, state) => {
    return ScriptGenResource.loadSparkSqlResponse(payload.workspaceId, payload.scorecardId);
  },
  onCompleteSuccess: (result) => result
};
const loadScriptGeneratorDataEpic = loadResourcesUtils(loadScriptGeneratorDataArgs);
const defaultReducerState = {
  error: "",
  emptyScorecardResponse: {},
  metricPowerResponse: {},
  scriptGeneratorResponse: {},
  extensionContext: {
    scorecardId: "",
    stepId: "",
    controlVariantName: "",
    treatmentVariantName: "",
    startTime: "",
    endTime: "",
    nochrome: true,
    rollupType: "",
    metricName: "",
    analysisTemplate: "",
    scorecardType: "",
    primarySegmentName: "",
    primarySegmentValue: "",
    secondarySegmentName: "",
    secondarySegmentValue: "",
    layout: ""
  }
};
const reducer = (state = defaultReducerState, action) => {
  state = loadEmptyScorecardExtensionDataEpic.reduxChange(state, action);
  state = loadMetricPowerExtensionDataEpic.reduxChange(state, action);
  state = loadScriptGeneratorDataEpic.reduxChange(state, action);
  switch (action.type) {
    case actionTypes.SET_USER_CONTEXT:
      let setUserContextAction2 = action;
      return __spreadProps(__spreadValues({}, state), {
        extensionContext: setUserContextAction2.payload
      });
    default:
      return state;
  }
};
const setUserContextAction = (context) => {
  return {
    type: actionTypes.SET_USER_CONTEXT,
    payload: context
  };
};
const setUserPartialContextAction = (context) => {
  return {
    type: actionTypes.SET_PARTIAL_USER_CONTEXT,
    payload: context
  };
};
export {
  loadEmptyScorecardExtensionDataEpic as a,
  loadScriptGeneratorDataEpic as b,
  setUserPartialContextAction as c,
  defaultReducerState as d,
  loadMetricPowerExtensionDataEpic as l,
  produceQueryStringEpic as p,
  reducer as r,
  setUserContextAction as s
};
//# sourceMappingURL=Extensions.ducks-1ce34bb1.js.map
